<template>
  <div class="view">
    <NavBar>
      <BNavbarNav class="overflow-hidden">
        <BNavItem @click.prevent="sidebarVisible = true">
          <Icon icon="bi:list" style="font-size: 20px" />
        </BNavItem>
        <BNavbarBrand class="text-nowrap overflow-hidden">
          Network Gallery
          <small title="A web application to browse, manage and share your pictures" class="d-none d-md-block">
            A web application to browse, manage and share your pictures
          </small>
        </BNavbarBrand>
      </BNavbarNav>
    </NavBar>

    <BOffcanvas v-model="sidebarVisible" title="Navigation" bodyScrolling>
      <BNav class="px-3" vertical>
        <BNavItem class="mt-3" link-classes="btn btn-primary" to="/search">
          <Icon icon="bi:search" /> Bilder suchen/filtern
        </BNavItem>
        <hr />
        <BForm @submit.prevent="addShareCode(shareForm.code)">
          <BFormGroup label="Freigabe-Code">
            <BFormInput v-model="shareForm.code" type="text" />
          </BFormGroup>
          <BButton type="submit"><Icon icon="bi:eye-fill" /> Freigabe anzeigen</BButton>
        </BForm>
      </BNav>
    </BOffcanvas>

    <div class="home">
      <Loader :is-loading="isLoading" />
      <Album v-for="album in albums" :key="album.id" :album="album" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted } from 'vue'
import { BButton, BForm, BFormGroup, BFormInput, BNav, BNavItem, BNavbarBrand, BNavbarNav, BOffcanvas } from 'bootstrap-vue-next'
import { Icon } from '@iconify/vue'
import axios from 'axios'
import Album from '@/components/Album.vue'
import Loader from '@/components/Loader.vue'
import NavBar from '@/components/NavBar.vue'
import { CookieManager } from '@/tools/CookieManager'
import { setSubPageTitle } from '@/stores/ui'
import AlbumModel from '@/models/Album'

const albums = ref<AlbumModel[]>([])
const isLoading = ref(false)
const sidebarVisible = ref(false)
const shareForm = reactive({ code: '' })
let loader: Promise<void> | null = null

function refreshAlbums() {
  if (!loader) {
    isLoading.value = true
    loader = axios.get('/api/albums').then(response => {
      albums.value = response.data
    }).catch(reason => {
      console.error(reason)
    }).finally(() => {
      loader = null
      isLoading.value = false
    })
  }
}

function addShareCode(code: string) {
  shareForm.code = ''
  if (CookieManager.addShareCode(code)) {
    loader = null
    refreshAlbums()
  }
}

onMounted(() => {
  refreshAlbums()
  setSubPageTitle('')
})
</script>

<style lang="scss">
@import '../main.scss';

.view {
  padding-top: 56px;

  @include media-breakpoint-up(md) {
    padding-top: 61px;
  }
}

.home {
  padding: 4px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;

  @include media-breakpoint-up(md) {
    padding: 8px;
  }
}
</style>
